
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/[name]",
      function () {
        return require("private-next-pages/news/[name].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news/[name]"])
      });
    }
  